enum BNGPartners {
  NONE = 'NONE',
  KADY = 'KADY',
  BLUE_GREEN = 'BGS',
}

export { BNGPartners }
